import {
  Box,
  Button,
  Icon,
  Paper,
  Skeleton,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface IFerramanetasDetalhe {
  mostraBotaoNovo?: boolean;
  textoBotaoNovo?: string;
  mostraBotaoApagar?: boolean;
  mostraBotaoSalvar?: boolean;
  mostraBotaoVoltar?: boolean;
  mostraBotaoSalvarEVoltar?: boolean;
  textoBotaoAdicional?: string;
  textBotaoSalvar?: string;
  textoBotaoAdicional2?: string;

  mostraBotaoNovoCarregando?: boolean;
  textoBotaoNovoCarregando?: string;
  mostraBotaoApagarCarregando?: boolean;
  mostraBotaoSalvarCarregando?: boolean;
  mostraBotaoVoltarCarregando?: boolean;
  mostraBotaoSalvarEVoltarCarregando?: boolean;
  mostrarBotaoAdicional?: boolean;
  iconBotaoAdicional?: string;
  mostrarBotaoAdicional2?: boolean;
  iconBotaoAdicional2?: string;
  iconeBotaoSalvar?: string;
  iconeBotaoNovo?: string;

  aoClicarBotaoNovo?: () => void;
  aoClicarBotaoApagar?: () => void;
  aoClicarBotaoSalvar?: () => void;
  aoClicarBotaoVoltar?: () => void;
  aoClicarBotaoVoltarESalvar?: () => void;
  aoClicarBotaoAdicional?: () => void;
  aoClicarBotaoAdicional2?: () => void;
}

export function FerramanetasDetalhe({
  mostraBotaoNovo = true,
  textoBotaoNovo = "Novo",
  mostraBotaoApagar = true,
  mostraBotaoSalvar = true,
  mostraBotaoSalvarEVoltar = true,
  mostraBotaoVoltar = true,
  aoClicarBotaoNovo,
  aoClicarBotaoApagar,
  aoClicarBotaoSalvar,
  aoClicarBotaoVoltar,
  aoClicarBotaoVoltarESalvar,
  mostraBotaoApagarCarregando = false,
  mostraBotaoNovoCarregando = false,
  mostraBotaoSalvarCarregando = false,
  mostraBotaoSalvarEVoltarCarregando = false,
  mostraBotaoVoltarCarregando = false,
  textoBotaoAdicional,
  mostrarBotaoAdicional = false,
  iconBotaoAdicional = "add_circle",
  mostrarBotaoAdicional2 = false,
  iconBotaoAdicional2 = "add_circle",
  textoBotaoAdicional2,
  aoClicarBotaoAdicional,
  textBotaoSalvar = "Salvar",
  aoClicarBotaoAdicional2,
  iconeBotaoNovo = "add",
  iconeBotaoSalvar = "save",
}: IFerramanetasDetalhe) {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down(977));
  return (
    <Box
      component={Paper}
      padding="5px"
      display="flex"
      alignItems="center"
      flexWrap={mdDown ? "wrap" : "nowrap"}
      justifyContent="end"
      gap="5px"
      marginBottom="20px"
    >
      {mostraBotaoSalvar && !mostraBotaoSalvarCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="contained"
          onClick={aoClicarBotaoSalvar}
          startIcon={<Icon>{iconeBotaoSalvar}</Icon>}
        >
          {textBotaoSalvar}
        </Button>
      )}

      {mostraBotaoSalvarCarregando && <Skeleton width={110} height={60} />}

      {mostraBotaoNovo && !mostraBotaoNovoCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoNovo}
          startIcon={<Icon>{iconeBotaoNovo}</Icon>}
        >
          {textoBotaoNovo}
        </Button>
      )}

      {mostraBotaoNovoCarregando && <Skeleton width={110} height={60} />}

      {mostraBotaoApagar && !mostraBotaoApagarCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoApagar}
          startIcon={<Icon>delete</Icon>}
        >
          Apagar
        </Button>
      )}

      {mostraBotaoApagarCarregando && <Skeleton width={110} height={60} />}

      {mostrarBotaoAdicional && !mostraBotaoSalvarEVoltarCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoAdicional}
          startIcon={<Icon>{iconBotaoAdicional}</Icon>}
        >
          {textoBotaoAdicional}
        </Button>
      )}

      {mostrarBotaoAdicional2 && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoAdicional2}
          startIcon={<Icon>{iconBotaoAdicional2}</Icon>}
        >
          {textoBotaoAdicional2}
        </Button>
      )}

      {mostraBotaoSalvarEVoltar && !mostraBotaoSalvarEVoltarCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoVoltarESalvar}
          startIcon={<Icon>save</Icon>}
        >
          Salvar e voltar
        </Button>
      )}

      {mostraBotaoSalvarEVoltarCarregando && (
        <Skeleton width={110} height={60} />
      )}

      {mostraBotaoVoltar && !mostraBotaoVoltarCarregando && (
        <Button
          color="primary"
          disableElevation
          variant="outlined"
          onClick={aoClicarBotaoVoltar}
          startIcon={<Icon>arrow_back</Icon>}
        >
          Voltar
        </Button>
      )}

      {mostraBotaoVoltarCarregando && <Skeleton width={110} height={60} />}
    </Box>
  );
}
